import styled from 'styled-components';
import StopStatusLog from './container';

export default styled(StopStatusLog)`
  display: flex;
  flex: 1;
  height: 100%;

  > * {
    width: 33.33%;
  }
`;
